import { Controller } from '@hotwired/stimulus';

// Opens and closes a menu or drawer. Replaces Flowbite, whose script re-ran on
// every page change and stacked a second click handler on the same button:
// one tap opened the menu and the other closed it straight away.
// Closes on a tap outside, on Escape, and before Turbo saves the page.
export default class extends Controller {
  static targets = ['button', 'panel'];
  static values = { hiddenClass: { type: String, default: 'hidden' } };

  connect() {
    this.outside = (event) => {
      if (this.open && !this.element.contains(event.target)) this.close();
    };
    this.escape = (event) => event.key === 'Escape' && this.close();
    this.beforeCache = () => this.close();
    document.addEventListener('click', this.outside);
    document.addEventListener('keydown', this.escape);
    document.addEventListener('turbo:before-cache', this.beforeCache);
  }

  disconnect() {
    document.removeEventListener('click', this.outside);
    document.removeEventListener('keydown', this.escape);
    document.removeEventListener('turbo:before-cache', this.beforeCache);
  }

  get open() {
    return (
      this.hasPanelTarget &&
      !this.panelTarget.classList.contains(this.hiddenClassValue)
    );
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.open) this.close();
    else this.show();
  }

  show() {
    this.panelTarget.classList.remove(this.hiddenClassValue);
    this.buttonTargets.forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }

  close() {
    if (!this.hasPanelTarget) return;
    this.panelTarget.classList.add(this.hiddenClassValue);
    this.buttonTargets.forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
}
